/* eslint-disable class-methods-use-this */
import { createBrowserRouter, matchRoutes, RouterProviderProps } from 'react-router-dom'

import env from '@core/env'
import {
  createReactRouterV6DataOptions,
  faro,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
  withFaroRouterInstrumentation,
} from '@grafana/faro-react'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

import { ObservabilityProviderInterface, tracePropagationTargetsByEnv } from '.'
import { ignoredErrorPatterns } from './error-filters'

class GrafanaProvider implements ObservabilityProviderInterface {
  setup(): any {
    return initializeFaro({
      url: env.GRAFANA_URL,
      isolate: true,
      app: {
        name: 'ftg-ui',
        version: '1.0.0',
        environment: env.ENV,
      },
      ignoreErrors: ignoredErrorPatterns,
      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),
        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation({
          instrumentationOptions: {
            propagateTraceHeaderCorsUrls: tracePropagationTargetsByEnv[env.ENV] || [],
          },
        }),
        // React integration for React applications.
        new ReactIntegration({
          router: createReactRouterV6DataOptions({
            matchRoutes,
          }),
        }),
      ],
    })
  }

  captureMessage(message: string): void {
    faro.api.pushLog([message])
  }

  captureException(error: Error): void {
    faro.api.pushError(error)
  }

  createRouter(router): RouterProviderProps['router'] {
    return withFaroRouterInstrumentation(createBrowserRouter(router))
  }

  setCypressId(): void {
    faro.api.setSession({
      attributes: {
        cypress: 'true',
      },
    })
  }
}

export default GrafanaProvider
